import { ResourceType } from "@common/types/auditLog";
import { ActivityProcessName } from "../process-names";
import { HistoryGroupBy } from "./history-fields";
import type { HistorySourceTypeConfig } from "./history-source-config";
import {
    applyTransactionUpdate,
    checkAndMergeSimilarCounterparties,
    normalizeCategorizationForTheSameTransactions,
} from "./enrichment-activity-source-types";
import { TRANSACTION_FIELDS } from "./transaction-sources";

export const enrichmentSources: HistorySourceTypeConfig[] = [
    {
        sourceType: ActivityProcessName.TRANSACTION_ENRICHMENT,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: ActivityProcessName.TRANSACTION_ENRICHMENT_NORMALIZATION,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: ActivityProcessName.TRANSACTION_COUNTERPARTY_ENRICHMENT,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: ActivityProcessName.TRANSACTION_ENRICHMENT_SIDE_EFFECTS,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: ActivityProcessName.TRANSACTION_SPLIT_RULE_APPLICATION,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: applyTransactionUpdate,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: false,
    },
    {
        sourceType: normalizeCategorizationForTheSameTransactions,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: checkAndMergeSimilarCounterparties,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
];
